import React, { Fragment } from 'react'
import audiobook1 from "../../Assets/Images/audiobook1.png";
import playBtn from "../../Assets/Images/play-button.png";
import { Link } from 'react-router-dom';



const AudioCard = ({ key, data }) => {

    return (
        <Fragment>
            <Link to={{ pathname: "/book-detail" }} state={{ data }}>
                <div key={key} className="card audio-card bg-dark border-0 p-2">
                    <div className="row align-items-center">
                        <div className="col-auto">
                            <img src={data?.book_img} className='rounded' style={{ objectFit: "cover" }} width={"140px"} height={"200px"} alt="" />
                        </div>
                        <div className="col">
                            <small>
                                {data?.author_name}
                            </small>
                            <p className='audio-card-title mb-2  text-light'>
                                {data?.title}
                            </p>

                            {/* <p className='s-14 text-light'>{subline}</p> */}

                            <img src={playBtn} width={"30px"} alt="" />
                        </div>
                    </div>
                </div>
            </Link>
        </Fragment>
    )
}

export default AudioCard